import tokenizer from '@datalas/tokenizer';

export default (breakdown, data, tokenContext) => {
  const { statements, tokens } = breakdown;

  return tokenizer(data, tokenContext, statements, tokens);
};
